package app.smartcoding.realrate.presentation.util

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation

class NumberFormattingVisualTransformation : VisualTransformation {
    override fun filter(text: AnnotatedString): TransformedText {

        if (text.isBlank()) return TransformedText(AnnotatedString(""), OffsetMapping.Identity)

        val sign = if (text.startsWith("-")) "-" else ""

        val intPart = text.text
            .trimStart('-')
            .takeWhile(Char::isDigit)
            .withIndex()
            .reversed()
            .chunked(3)
            .reversed()
            .flatMapIndexed { groupNumber, group ->
                val pairs = group.reversed().map { (index, char) ->
                    Triple(
                        index + 1 + sign.length,
                        index + groupNumber + 1 + sign.length,
                        char
                    )
                }
                val splitter = pairs.last().run { Triple(first, second + 1, ' ') }
                pairs + splitter
            }
            .dropLastWhile { it.third == ' ' }

        val remindedPart = text.text
            .split('.')
            .drop(1)
            .firstOrNull()
            ?.let { ".$it" }
            ?.mapIndexedNotNull { index, c ->
                intPart.lastOrNull()?.run {
                    Triple(first + index + 1, second + index + 1, c)
                }
            }
            ?: emptyList()
        val wholeParts = if (sign.isNotEmpty()) listOf(Triple(1, 1, sign[0])) + intPart + remindedPart else intPart + remindedPart
        val formattedText = wholeParts.joinToString("") { it.third.toString() }

        val originalToTransformed: Map<Int, Int> = wholeParts.associate { it.first to it.second }
        val transformedToOriginal: Map<Int, Int> = wholeParts.associate { it.second to it.first }

        val offsetMapping = object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int = originalToTransformed[offset] ?: 0
            override fun transformedToOriginal(offset: Int): Int = transformedToOriginal[offset] ?: 0
        }

        return TransformedText(AnnotatedString(formattedText), offsetMapping)
    }
}
